<script>
import {mapGetters} from "vuex";
import AnalyticsDetailRow from "@/components/MultiConnect/Analytics/AnalyticsDetailRow.vue";

export default {
  name: "MessagingAnalytics",
  components: {AnalyticsDetailRow},
  props: {
    isPdf: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      totalAttendeesEngagedViaMessagesTooltip: 'This relates to attendees who sent a message via Pappyon chat feature during the event reporting period.',
      totalMessageSentTooltip: 'Total messages sent by attendees via Pappyon chat feature during the event reporting period. This metric is to demonstrate how engaged attendees are on a platform-wide basis.'
    }
  },
  computed: {
    ...mapGetters(["currentEvent", "linkedSessions", "linkedSubEvents"]),
    totalMessagesSent() {
      return this.currentEvent.analyticsData.totalMessagesSent.toLocaleString();
    },
    totalAttendeesEngatedViaMessages() {
      return this.currentEvent.analyticsData.totalAttendeesEngatedViaMessages.toLocaleString();
    },
    noOfChatRoomsEnabled() {
      let noOfEnabledChatRooms = 0;
      if (this.currentEvent.enableChatroom) noOfEnabledChatRooms++;
      this.linkedSubEvents.forEach((subEvent) => {
        if (subEvent.enableChatroom) noOfEnabledChatRooms++;
      });
      this.linkedSessions.forEach((session) => {
        if (session.enableChatroom) noOfEnabledChatRooms++;
      });
      return noOfEnabledChatRooms.toLocaleString();
    }
  }
}
</script>

<template>
  <div>
    <v-card :outlined="isPdf ? false : true" :height="370">
      <v-card-title>Messaging</v-card-title>
<!--      <v-divider/> isPdf ? null :  -->
      <div class="px-4 pb-4">
        <AnalyticsDetailRow title="Total attendees engaged via chat feature" :value="totalAttendeesEngatedViaMessages"
                            :show-view-button="false"
                            :subtitle="isPdf ? totalAttendeesEngagedViaMessagesTooltip : ''"
                            :tooltip="isPdf ? '' : totalAttendeesEngagedViaMessagesTooltip"
        />
        <v-divider/>
        <AnalyticsDetailRow title="Total messages sent" :value="totalMessagesSent" :show-view-button="false"
                            :subtitle="isPdf ? totalMessageSentTooltip : ''"
                            :tooltip="isPdf ? '' : totalMessageSentTooltip"
        />
        <v-divider/>
        <AnalyticsDetailRow title="Total chat rooms enabled" :value="noOfChatRoomsEnabled" :show-view-button="false"/>
        <v-divider/>
        <AnalyticsDetailRow title="Total chat rooms used" value="-" :show-view-button="false"/>
      </div>
    </v-card>
  </div>
</template>

<style scoped>

</style>